<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 1a4 4 0 00-4 4 .75.75 0 001.5 0A2.5 2.5 0 015 2.5h2.112a.04.04 0 01.04.044A9.518 9.518 0 014.63 7.955l-.066.07C3.504 9.152 4.303 11 5.85 11h.46c.658 0 1.191.534 1.191 1.191v.79c0 .242-.001.495.06.722a1.75 1.75 0 001.237 1.237c.227.061.48.06.722.06H11a4 4 0 004-4 .75.75 0 00-1.5 0 2.5 2.5 0 01-2.5 2.5H9.583c-.161 0-.258 0-.33-.004a.665.665 0 01-.07-.005.25.25 0 01-.174-.174.655.655 0 01-.006-.07 8.225 8.225 0 01-.003-.33v-.726A2.692 2.692 0 006.308 9.5H5.85a.265.265 0 01-.193-.447l.066-.07a11.018 11.018 0 002.92-6.263A1.54 1.54 0 007.111 1H5zm5 7a1 1 0 100-2 1 1 0 000 2zm1-7a4 4 0 014 4 .75.75 0 01-1.5 0A2.5 2.5 0 0011 2.5.75.75 0 0111 1zM1 11a4 4 0 004 4 .75.75 0 000-1.5A2.5 2.5 0 012.5 11 .75.75 0 001 11z"
    fill="currentColor"
  />
</svg>
